import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.speedControl || initialState;

export const selectSpeedControl = createSelector([selectSlice], state => state);

export const selectSpeedControlReport = createSelector(
  [selectSlice],
  state => state,
);
